import React from 'react'
import { Table, Row, Col, Form } from 'react-bootstrap';
import ManageSubsByUser from 'alert_subscriptions/ManageSubsByUser'
import DefaultAvatar from 'utils/DefaultAvatar'
import CustomAvatar from 'utils/CustomAvatar'
import jsDig from 'utils/jsDig'

class SubsByUser extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      selectedUser: jsDig(["users", this.props.defaultUser], this.props) ? this.props.defaultUser : Object.keys(this.props.users)[0],
      users: [],
      searchVisible: false
    };
  }

  toggleSearch(e) {
    let arrow = e.target.querySelector('.fas');
    if (arrow.classList.contains('fa-sort-up')) {
      arrow.classList.remove('fa-sort-up');
      arrow.classList.add('fa-sort-down');
    } else {
      arrow.classList.remove('fa-sort-down');
      arrow.classList.add('fa-sort-up');
    }
    this.setState({searchVisible: !this.state.searchVisible});
  }

  searchClients(event) {
    let filter = event.target.value;
    let clients = document.getElementsByClassName("client-row-by-user");
    this.props.searchClients(filter, clients);
  }

  searchUsers(event) {
    let filter = event.target.value.toLowerCase();
    let filteredUsers = {};
    let count = 0;
    Object.keys(this.props.users).forEach((userEmail) => {
      let user = this.props.users[userEmail];
      // If less than 10 results displayed && name or email matches input
      if (count < 10 && (userEmail.toLowerCase().includes(filter) || user.name.toLowerCase().includes(filter))) {
        filteredUsers[userEmail] = user;
        count++;
      }
    });
    this.setState({ users: filteredUsers });
  }

  changeUser(event) {
    let email = event.target.getAttribute("data-email");
    if (email && email != "") {
      this.setState({ selectedUser: email });
    }
  }

  render() {
    let usersList = this.state.users;
    let users = Object.keys(usersList).map((userEmail) => {
      let user = usersList[userEmail];
      return (
        <a key={user.id} data-email={userEmail} onClick={(e) => this.changeUser(e)}>
          <span style={{ pointerEvents: "none" }} className="change-user">+</span>
          <span style={{ pointerEvents: "none" }}>{user.name}</span>
        </a>
      )
    })


    let selectedUser = this.props.users[this.state.selectedUser];
    let bigAvatar = <DefaultAvatar dim="100x100" name={selectedUser.name} className="avatar m-4 d-inline-block" department={selectedUser.department} />
    if (selectedUser.avatar_big) {
      bigAvatar = <CustomAvatar src={selectedUser.avatar_big} className="avatar m-4 d-inline-block" department={selectedUser.department} />
    }
    return (
      <>
        <h3>Subscriptions By User</h3>
        <div className="subs-by-user off-color-bg">
          <Row>
            <Col className="d-flex flex-wrap align-items-start px-4">
              <div>
                { bigAvatar }
              </div>
              <div className="by-user-search">
                <div className="user-search-inner">
                  <div className="search-button" onClick={(e) => this.toggleSearch(e)}>
                    <h3 className="d-flex justify-content-between" style={{pointerEvents: "none"}}>{selectedUser.name}<i style={{pointerEvents: "none"}} className="fas fa-sort-down"></i></h3>
                  </div>
                  <div className={`user-select ${this.state.searchVisible ? "" : "d-none"}`}>
                    <div className="divider"></div>
                    <span className="fa fa-search"></span>
                    <input type="text" placeholder="Search user" onChange={(e) => this.searchUsers(e)} />
                    <div className="user-list">
                      {users}
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          <div className="table-responsive">
            <Table striped className="mt-2 table-white">
              <thead>
                <tr>
                  <th className="text-center search-color head-1" rowSpan="2">
                    Client Name
                    <div className="client-search">
                      <span className="fa fa-search"></span>
                      <input onChange={(e) => this.searchClients(e)} />
                    </div>
                  </th>
                  <th colSpan="4" className="text-center ppc-color head-1">PPC</th>
                  <th className="text-center seo-color head-1" rowSpan="2">SEO</th>
                </tr>
                <tr>
                  <th className="text-center ppc-color head-2">Search</th>
                  <th className="text-center ppc-color head-2">Social</th>
                  <th className="text-center ppc-color head-2">Display</th>
                  <th className="text-center ppc-color head-2">Video</th>
                </tr>
              </thead>
              <tbody>
                {
                  this.props.clients.map((client) => {
                  
                    return (
                      <tr key={client.id} className="client-row-by-user" data-client-name={client.company_name}>
                        <th className="company-name"><h4 style={{ fontSize: "16px", marginTop: "8px" }}>{client.company_name}</h4></th>
                        <td><ManageSubsByUser addUser={this.props.addUser} removeUser={this.props.removeUser} selectedUser={this.state.selectedUser} subscribed_users={client.search_subs} section_id={client.search_section_id} section_name="SearchSection" /></td>
                        <td><ManageSubsByUser addUser={this.props.addUser} removeUser={this.props.removeUser} selectedUser={this.state.selectedUser} subscribed_users={client.social_subs} section_id={client.social_section_id} section_name="SocialSection" /></td>
                        <td><ManageSubsByUser addUser={this.props.addUser} removeUser={this.props.removeUser} selectedUser={this.state.selectedUser} subscribed_users={client.display_subs} section_id={client.display_section_id} section_name="DisplaySection" /></td>
                        <td><ManageSubsByUser addUser={this.props.addUser} removeUser={this.props.removeUser} selectedUser={this.state.selectedUser} subscribed_users={client.video_subs} section_id={client.video_section_id} section_name="VideoSection" /></td>
                        <td><ManageSubsByUser addUser={this.props.addUser} removeUser={this.props.removeUser} selectedUser={this.state.selectedUser} subscribed_users={client.seo_subs} section_id={client.seo_section_id} section_name="SeoSection" /></td>
                      </tr>
                    )
                  })
                }
              </tbody>
            </Table>
          </div>
        </div>
      </>
    )
  }
}

export default SubsByUser;
